import { LogLevel, Logger } from '@suntex.core/logging';
import { Entities_FocusMode } from '@suntex.fim/api-client';
import { GradeLevel } from '@suntex.fim/enums';

import { PlayerIndexResponse } from '../context/types';

const logger = Logger.for(['@suntex.fim.player', 'utils', 'focus'], {
  level: LogLevel.Trace,
});

export function getFocusOptions(
  playerInfo: PlayerIndexResponse,
): readonly GradeLevel[] {
  const fm = getFocusMode(playerInfo);
  // TODO: remove the unnecessary nullish coalescing operator at the next opportunity. It is only here to accomodate e2e tests because we are making breaking API changes
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  return fm.gradeLevels ?? [];
}

export function getModuleTagsForGradeLevels(
  focus: readonly GradeLevel[] | undefined,
): readonly string[] | undefined {
  if (!focus?.length) return undefined;
  return focus.map((gradeLevel) => `grade:${gradeLevel}`);
}

function getFocusMode(playerInfo: PlayerIndexResponse): Entities_FocusMode {
  // TODO: remove these unnecessary conditions at the next opportunity.
  // They are only here to accomodate e2e tests because we are making breaking API changes
  // In the future, we should roll out backwards compatible API changes with deprecations first
  // rather than coupling backend and frontend changes together like this

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (playerInfo.playerFocusMode.gradeLevels?.length > 0)
    return playerInfo.playerFocusMode;

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (playerInfo.teamFocusMode.gradeLevels?.length > 0)
    return playerInfo.teamFocusMode;

  logger.warn('No focus mode specified');
  logger.trace(() => ({
    playerFocusMode: playerInfo.playerFocusMode,
    teamFocusMode: playerInfo.teamFocusMode,
  }));

  return {
    gradeLevels: [],
  };
}
